<template>
  <div class="weater-science">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      style="height: 100%"
    >
      <van-tabs
        v-model="active"
        @click="handleActiveNav()"
        style="height: 100%"
        swipeable
      >
        <van-tab
          v-for="(item, index) in items"
          :key="index"
          style="7%"
          :title="item"
        >
          <!-- <template #title>{{item}}</template> -->
        </van-tab>
        <div class="article">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="(item, index) in van_swipe" :key="index" @click="skip1(item.id)">
              <img :src="`${item.titleImageAddress}`" alt />
              <div class="title">{{ item.title }}</div>
            </van-swipe-item>
          </van-swipe>
          <div class="lists">
            <ul>
              <template v-for="(item, index) in lists">
                <li
                  id="li1"
                  @click="skip(item.id)"
                  :key="index"
                  v-if="item.videoAddress === null"
                >
                  <span class="sp1">
                    <img :src="`${item.titleImageAddress}`" alt />
                    <span class="sp2">
                      <p>{{ item.title }}</p>
                      <p>
                        <i>
                          {{ sj[index] }} |
                          <b>{{ item.issued }}</b>
                        </i>
                        <i>
                          <img src="./imgs/order.png" alt />
                          浏览量{{ item.pageView }}
                        </i>
                      </p>
                    </span>
                  </span>
                </li>
                <li id="li2" :key="index" v-else>
                  <transition name="el-zoom-in-top">
                    <span class="li2_sp1" v-if="show">{{ item.title }}</span>
                  </transition>
                  <span class="li2_sp2">
                    <video
                      :src="`${item.videoAddress}`"
                      controls="controls"
                      @play="vid_play(item.id, index)"
                      @ended="vid_ended(item.id, index)"
                    ></video>
                  </span>
                  <span class="li2_sp3">
                    <i>
                      <i>
                        {{ sj[index] }} |
                        <p>{{ item.issued }}</p>
                      </i>
                    </i>
                    <i>
                      <img src="./imgs/浏览量.png" alt />
                      浏览量{{ item.pageView }}
                    </i>
                    <i @click="dz(index, $event)" class="cla">
                      点赞{{ item.give }}
                    </i>
                  </span>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </van-tabs>
    </van-pull-refresh>
  </div>
</template>
<script>
import Vue from "vue";
import { PullRefresh } from "vant";
import axios from "axios";
import { Toast } from "vant";
import moment from "moment";
import { Swipe, SwipeItem } from "vant";
// 加载jq
import $ from "jquery";
Vue.use(PullRefresh);
Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  name: "Science",
  data() {
    return {
      active: "",
      items: [],
      flag_arr: [],
      flag_id: "",
      isLoading: false,
      lists: [],
      van_swipe:[],
      sj: [],
      flag: "",
      dianzan: "",
      show: true,
    };
  },
  watch: {
    active() {
      this.flag_id = this.flag_arr[this.active];
      this.request1(this.flag_id);
    },
  },
  mounted() {
    this.request();
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        Toast("刷新成功");
        this.isLoading = false;
        this.request();
      }, 1000);
    },
    handleActiveNav() {
      this.flag_id = this.flag_arr[this.active];
      this.request1(this.flag_id);
    },
    //点赞
    dz(idx, e) {
      if ($(e.target)[0].className == "cla") {
        $(e.target).addClass("red");
        $(e.target).removeClass("cla");
        this.request2(this.lists[idx].id);
      } else {
        $(e.target).removeClass("red");
        $(e.target).addClass("cla");
        this.request3(this.lists[idx].id);
      }
    },
    skip(id) {
      this.$router.push({
        name: "details",
        params: {
          id: id,
        },
      });
    },
    skip1(id) {
      this.$router.push({
        name: "details",
        params: {
          id: id,
        },
      });
    },
    // 播放
    vid_play(id, idx) {
      axios
        .get("/wxapi/InformationRelease/queryById?id=" + id + "")
        .then((res) => {});
      $("#li2:nth-child(" + (idx + 1) + ") .li2_sp1").css("display", "none");
    },
    // 播放完毕
    vid_ended(id, idx) {
      $("#li2:nth-child(" + (idx + 1) + ") .li2_sp1").css("display", "block");
    },
    request() {
      axios.get("/wxapi/issued/findAll").then((res) => {
        this.flag_id = res.data.data[0].id;
        this.items=[]
        this.flag_arr=[]
        res.data.data.forEach((ele) => {
          this.items.push(ele.name);
          this.flag_arr.push(ele.id);
        });
        this.request1(this.flag_id);
      });
    },
    request1(id) {
      axios
        .get("/wxapi/InformationRelease/queryPageTitle?pageNum=1&pageSize=10&issuedId=" + id +"")
        .then((res) => {
          this.lists=[]
          this.van_swipe=[]
          res.data.list.forEach((ele,index) => {
            if (ele.startLbImg === 0) {
              this.lists.push(ele)
            }else if(ele.startLbImg === 1){
              this.van_swipe.push(ele)
            }
            var time = moment(
              res.data.list[index].publishTime,
              "YYYY-MM-DD"
            ).format("MM-DD");
            this.sj.push(time);
          });
        });
    },
    // 点赞
    request2(id) {
      axios
        .get("/wxapi/InformationRelease/addGive?id=" + id + "")
        .then((res) => {
          this.lists.forEach((ele) => {
            if (ele.id == id) {
              ele.give = res.data.data.give;
            }
          });
        });
    },
    // 取消赞
    request3(id) {
      axios
        .get("/wxapi/InformationRelease/cancelGive?id=" + id + "")
        .then((res) => {
          this.lists.forEach((ele) => {
            if (ele.id == id) {
              ele.give = res.data.data.give;
            }
          });
        });
    },
  },
};
</script>
<style lang="less">
.van-swipe__indicators {
  left: 90% !important;
}
.van-tabs__wrap--scrollable .van-tab {
  flex-basis: 17% !important;
}
.van-tab {
  font-size: 33px;
  color: #353535;
  width: 140px;
  -webkit-box-flex: none;
  -webkit-flex: none;
  flex: none;
}
.van-tab--active {
  color: #1d1d1d;
  font-weight: 500;
  font-weight: 700;
}
.van-tabs__wrap {
  height: 7% !important;
}
.van-tabs__content {
  height: 93% !important;
}
</style>
<style lang="less" scoped>
.weater-science {
  background-color: #edf2f7;
  height: 100%;
}
.cla {
  background: url(./imgs/点赞.png) no-repeat 4%;
  background-size: 28% 50%;
}
.red {
  color: red;
  z-index: 100;
  background: url(./imgs/点赞1.png) no-repeat 4%;
  background-size: 28% 50%;
}
.dis_none {
  display: none;
}
.article {
  height: 100%;
  .my-swipe {
    /deep/.van-swipe__track {
      .van-swipe-item {
        height: 29vh !important;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .title {
          position: absolute;
          font-size: 30px;
          line-height: 58px;
          bottom: 0;
          height: 58px;
          width: 100%;
          color: #fff;
          padding-left: 10px;
          background: rgba(17, 15, 15, 0.5);
        }
      }
    }
  }
  .lists {
    overflow: auto;
    height: 100%;
    padding-bottom: 3%;
    #li1 {
      height: 200px;
      width: 100%;
      margin-top: 15px;
      background: #fff;
      .sp1 {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        img {
          height: 98%;
          max-width: 28%;
        }
        .sp2 {
          flex: 1;
          height: 100%;
          p:nth-child(1) {
            height: 72%;
            width: 100%;
            padding: 1%;
            font-size: 35px;
            display: flex;
            align-items: center;
          }
          p:nth-child(2) {
            height: 28%;
            width: 100%;
            padding-left: 10px;
            padding-right: 10px;
            i:nth-child(1) {
              float: left;
              display: flex;
              align-items: center;
              height: 100%;
              width: 250px;
              font-size: 20px;
              b {
                color: #cc6f96;
                margin-left: 6px;
              }
            }
            i:nth-child(2) {
              float: right;
              display: flex;
              align-items: center;
              height: 100%;
              width: 150px;
              font-size: 20px;
              img {
                height: 48%;
                width: 19%;
                margin-right: 10px;
              }
            }
          }
        }
      }
    }
    #li2 {
      width: 100%;
      height: 480px;
      margin-top: 15px;
      position: relative;
      background-color: #fff;
    }
    #li2 .li2_sp1 {
      position: absolute;
      top: 0;
      height: 80px;
      width: 100%;
      color: #fff;
      line-height: 80px;
      font-size: 35px;
      padding-left: 10px;
      background: rgba(17, 15, 15, 0.5);
    }
    #li2 .li2_sp2 {
      height: 400px;
      width: 100%;
      display: block;
      video {
        width: 100%;
        height: 100%;
      }
    }
    #li2 .li2_sp3 {
      height: 80px;
      width: 100%;
      display: block;
      padding-left: 10px;
      i:nth-child(1) {
        float: left;
        display: flex;
        align-items: center;
        height: 100%;
        width: 260px;
        font-size: 25px;
        p {
          color: #cc6f96;
          margin-left: 6px;
        }
      }
      i:nth-child(2) {
        float: left;
        display: flex;
        align-items: center;
        height: 100%;
        width: 170px;
        margin-left: 150px;
        font-size: 25px;
        img:nth-child(1) {
          height: 48%;
          margin-right: 10px;
        }
      }
      i:nth-child(3) {
        float: left;
        display: flex;
        align-items: center;
        height: 100%;
        width: 150px;
        font-size: 25px;
        padding-left: 8%;
      }
    }
  }
}
</style>
